import React from "react";
import { Box, Typography } from "@material-ui/core";
import { CustomCard } from "../CustomCard";
import useStyles from "./styles";
import { Skeleton } from "@material-ui/lab";

function KPICard({ children, loading, ...props }) {
  const styles = useStyles();
  return loading ? (
    <CustomCard
      classes={styles.cardStyle}
      boxShadow="xs"
      borderRadius="xl"
      borderColor="secondary"
    >
      <Box className={styles.titleHeading}>
        <Skeleton variant="text" width="60%" height={24} />
      </Box>
      <Box
        className={styles.contentWrapper}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        bgcolor="background.paper"
      >
        <Skeleton variant="text" width="40%" height={55} />
        <Skeleton
          variant="rectangular"
          width={40}
          height={40}
          className={styles.buttonSkeleton}
        />
      </Box>
    </CustomCard>
  ) : (
    <CustomCard
      classes={styles.cardStyle}
      boxShadow="xs"
      borderRadius="xl"
      borderColor="secondary"
      {...props}
    >
      <Box>{children}</Box>
    </CustomCard>
  );
}

KPICard.Title = function Title({ children }) {
  const styles = useStyles();
  return (
    <Typography component="p" variant="body1" className={styles.title}>
      {children}
    </Typography>
  );
};

KPICard.Content = function Content({ children }) {
  const styles = useStyles();
  return (
    <Typography variant="h2" component="h2" className={styles.subTitle}>
      {children}
    </Typography>
  );
};

KPICard.Icon = function Icon({ children }) {
  const styles = useStyles();
  return <Box className={styles.iconContainer}>{children}</Box>;
};

export default KPICard;
